import Tile from 'app/src/engine/tiles/Tile';
import { createContext, useContext } from 'react';

export enum TileInteractionMode {
	AddTile,
	Wall,
	Robot,
	Star,
	Rotate,
	Copy,
}

type TileInteractionModeContext = {
	mode: TileInteractionMode;
	setMode(mode: TileInteractionMode): void;

	tile: Tile | null;
	setTile(tileDescription: Tile): void;
};

const context = createContext<TileInteractionModeContext | null>(null);

export function useTileInteractionModeContext(): TileInteractionModeContext {
	const contextValue = useContext(context);

	if (contextValue === null) {
		throw new Error(
			'useTileInteractionModeContext must be used within a TileInteractionModeContextProvider',
		);
	}

	return contextValue;
}

export const TileInteractionModeContextConsumer = context.Consumer;
export const TileInteractionModeContextProvider = context.Provider;
